import React, { Fragment } from 'react';

export default function PageContent(props) {
	return (
		<Fragment>
			<div className="mx-auto dark:bg-dark-bg">
				{props.children}
			</div>
		</Fragment>
	);
}
